import script from "./AddAccessoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAccessoryModal.vue?vue&type=script&setup=true&lang=js"

import "./AddAccessoryModal.vue?vue&type=style&index=0&id=68e3202a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e3202a"]])

export default __exports__